export function KpiCard({ icon: Icon, label, value, sub, variant, testid, onClick }) {
  return (
    <div
      className={`kpi-card ${variant || ""} ${onClick ? "clickable" : ""}`}
      onClick={onClick}
      data-testid={testid}
      role={onClick ? "button" : undefined}
    >
      <div className="kpi-icon"><Icon size={20} strokeWidth={2.2} /></div>
      <div className="label">{label}</div>
      <div className="value">{value}</div>
      <div className="sub">{sub}</div>
      {onClick && <div className="kpi-hint">Klik untuk drill-down →</div>}
    </div>
  );
}

export function ChartCard({ title, subtitle, children, action }) {
  return (
    <div className="card">
      <div className="card-head">
        <div>
          <h3 className="card-title">{title}</h3>
          {subtitle && <p className="card-subtitle">{subtitle}</p>}
        </div>
        {action}
      </div>
      {children}
    </div>
  );
}
